const MODULE = 'OTHER_FEE_OPTION'
export const GET_OPTION_CALCULATION_LIST = `${MODULE}/get_option_calculation_list`;
export const OPTION_CALCULATION_INFO = `${MODULE}/option_calculation_info`;
export const CREATE_OPTION_FEES = `${MODULE}/create_option_fees`;
export const UPDATE_OPTION_FEES = `${MODULE}/update_option_fees`;
export const REMOVE_OPTION_FEES = `${MODULE}/remove_option_fees`;
export const GET_NEW_OTHER_FEES = 'NEW_OTHER_FEES/get_new_other_fees';
export const GET_SINGLE_NEW_OTHER_FEES =
  'NEW_OTHER_FEES/get_single_new_other_fees';

export const FORM_DATA = {
  multiplier: '',
  amount: ''
};


